<!-- `nested` is set by the recursion below: blocks guarded by !nested render once, at the top level. -->
<ng-template #recursiveList let-list let-nested="nested">
  <ng-container *ngFor="let item of list | phdsoftOrderBy: { expression: 'Order', order: null, list: this }">
    <ng-container *ngIf="item?.PropertiesAttributes?.Visible">
      <h3
        class="mat-h3 properties-section-header"
        [class.is-expanded]="item.Expanded"
        [class.is-nested]="item?.Level > 0"
        (click)="item.Expanded = !item.Expanded"
      >
        <mat-icon aria-hidden="false" aria-label="Expanded">
          {{ item.Expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}
        </mat-icon>
        {{ item?.Label }}
      </h3>
      <ul
        *ngIf="item.Expanded"
        class="expanded-content"
        [class.is-nested]="item?.Level > 0"
      >
        <ng-container *ngIf="item?.ListFields?.length > 0">
          <!-- inert while busy (UAT 2 N4): the GENERAL fields (Label, Coating, ...) stay put during a move or a 3D regeneration. -->
          <li *ngFor="let field of item?.ListFields | phdsoftOrderBy: { expression: 'order', order: null, list: this }"
              class="busy-aware-field" [class.is-busy]="isBusy" [attr.inert]="isBusy ? '' : null">
            <ng-container *ngIf="field.visible" ngDefaultControl c4dwebDynamicField [field]="field" [group]="field.formGroup"></ng-container>
          </li>
        </ng-container>
        <ng-container *ngIf="item?.Children?.length > 0">
          <ng-container *ngTemplateOutlet="recursiveList; context: { $implicit: item?.Children, nested: true }">
          </ng-container>
        </ng-container>
      </ul>
    </ng-container>
  </ng-container>

  <!-- Top level only: this template recurses for every group with Children (finding 14). -->
  <!-- <ng-container *ngIf="showCompartments"> -->
  <ng-container *ngIf="!isMultiMode && showCompartments && !nested">
    <h3
      class="mat-h3 properties-section-header"
      [class.is-expanded]="compartmentsIsExpanded"
      (click)="compartmentsIsExpanded = !compartmentsIsExpanded"
    >
      <mat-icon aria-hidden="false" aria-label="Expanded">
        {{ compartmentsIsExpanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}
      </mat-icon>
        REGIONS &amp; SECTION
      <span class="relocation-status" *ngIf="isSaving">Saving…</span>
      <span class="relocation-status is-warning" *ngIf="!isSaving && gltfFailures.length > 0">3D model not updated</span>
    </h3>

    <ul *ngIf="compartmentsIsExpanded" class="compartments expanded-content">
      <li class="relocation-title">Section</li>
      <li>
        <p-dropdown class="relocation-dropdown"
                    [options]="sectionOptions" optionLabel="label" optionValue="value" optionDisabled="disabled"
                    [(ngModel)]="selectedSectionId" [ngModelOptions]="{ standalone: true }"
                    placeholder="Section" [filter]="true" filterBy="label" filterPlaceholder="Search…"
                    appendTo="body" styleClass="relocation-dropdown-input" [disabled]="isBusy"
                    (onChange)="onSectionChange()"></p-dropdown>
      </li>
      <li class="relocation-title">Regions</li>
      <li>
        <mat-checkbox [(ngModel)]="compartmentShared" [ngModelOptions]="{ standalone: true }" [disabled]="isBusy"
                      (change)="onSharedToggle()">
          Shared between two regions
        </mat-checkbox>
      </li>
      <li>
        <p-dropdown class="relocation-dropdown"
                    [options]="regionOptions" optionLabel="label" optionValue="value" optionDisabled="disabled"
                    [(ngModel)]="compartmentRegionIds[0]" [ngModelOptions]="{ standalone: true }"
                    placeholder="Region" [filter]="true" filterBy="label" filterPlaceholder="Search…"
                    appendTo="body" styleClass="relocation-dropdown-input" [disabled]="isBusy"
                    (onChange)="onCompartmentSlotChange(0)"></p-dropdown>
      </li>
      <li *ngIf="compartmentShared">
        <p-dropdown class="relocation-dropdown"
                    [options]="secondRegionOptions" optionLabel="label" optionValue="value" optionDisabled="disabled"
                    [(ngModel)]="compartmentRegionIds[1]" [ngModelOptions]="{ standalone: true }"
                    placeholder="Second region" [filter]="true" filterBy="label" filterPlaceholder="Search…"
                    appendTo="body" styleClass="relocation-dropdown-input" [disabled]="isBusy"
                    (onChange)="onCompartmentSlotChange(1)"></p-dropdown>
      </li>
      <ng-container *ngIf="gltfFailures.length > 0">
        <li class="relocation-title">3D model</li>
        <li class="gltf-failure" *ngFor="let failure of gltfFailures">
          <span class="gltf-failure-region">{{ failure.regionName }}</span>
          <span class="gltf-failure-error" *ngIf="failure.error">{{ failure.error }}</span>
        </li>
        <li>
          <button mat-stroked-button
                  type="button"
                  class="gltf-regenerate-action"
                  [disabled]="isBusy"
                  (click)="regenerateGltf()">
            <mat-icon>refresh</mat-icon>
            <span>{{ isRegeneratingGltf ? 'Regenerating…' : 'Regenerate 3D' }}</span>
          </button>
        </li>
      </ng-container>
    </ul>
  </ng-container>

  <ng-container *ngIf="!isMultiMode && degradationMode">
    <h3
      class="mat-h3 properties-section-header"
      [class.is-expanded]="degradationIsExpanded"
      (click)="degradationIsExpanded = !degradationIsExpanded"
    >
      <mat-icon aria-hidden="false" aria-label="Expanded">
        {{ degradationIsExpanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}
      </mat-icon>
        DEGRADATION
    </h3>

    <ul *ngIf="degradationIsExpanded" class="degradation expanded-content">
      <ng-container>
        <li class="informational-field">
          <div class="informational-label">ESTIMATED THICKNESS (mm)</div>
           <input class="informational-value" matInput disabled readonly placeholder="{{estimatedThickness}}" type="text"/>
        </li>
        <li class="informational-field">
          <div class="informational-label">SUBSTANTIAL CORROSION THICKNESS (mm)</div>
           <input class="informational-value" matInput disabled readonly placeholder="{{substantialCorrosionThickness}}" type="text"/>
        </li>
        <li class="informational-field">
          <div class="informational-label">EXCESSIVE CORROSION THICKNESS (mm)</div>
           <input class="informational-value" matInput disabled readonly placeholder="{{excessiveCorrosionThickness}}" type="text"/>
        </li>
        <li class="informational-field">
          <div class="informational-label">REMAINING LIFE (years)</div>
           <input class="informational-value" matInput disabled readonly placeholder="{{remainingLife}}" type="text"/>
        </li>
        <li class="informational-field">
          <div class="informational-label">CORROSION RATE (mm/year)</div>
           <input class="informational-value" matInput disabled readonly placeholder="{{corrosionRate}}" type="text"/>
        </li>
        <li class="informational-field">
          <div class="informational-label">ABSOLUTE DEGRADATION (%)</div>
           <input class="informational-value" matInput disabled readonly placeholder="{{absoluteDegradation}}" type="text"/>
        </li>
        <li class="informational-field">
          <div class="informational-label">RELATIVE DEGRADATION (%)</div>
           <input class="informational-value" matInput disabled readonly placeholder="{{relativeDegradation}}" type="text"/>
        </li>
        <li class="informational-field">
          <div class="informational-label">READING QUALITY</div>
           <input class="informational-value" matInput disabled readonly placeholder="{{readingQuality}}" type="text"/>
        </li>
        <li class="informational-field">
          <div class="informational-label">CORROSION RISK INDEX</div>
           <input class="informational-value" matInput disabled readonly placeholder="{{corrosionRiskIndex}}" type="text"/>
        </li>
      </ng-container>
    </ul>
  </ng-container>


  <ng-container *ngIf="!isMultiMode && showChangesHistory">
    <h3
      class="mat-h3 properties-section-header"
      [class.is-expanded]="changesHistoryIsExpanded"
      (click)="changesHistoryIsExpanded = !changesHistoryIsExpanded"
    >
      <mat-icon aria-hidden="false" aria-label="Expanded">
        {{ changesHistoryIsExpanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}
      </mat-icon>
        CHANGES
    </h3>

    <ul *ngIf="changesHistoryIsExpanded" class="changesHistory expanded-content">
      <li class="change-item" *ngFor="let change of changesHistory; let i = index">
        <div class="history-row history-date-row">
          <span class="history-label">Date</span>
          <span class="history-value">{{formatDate(change.updatedAt)}}</span>
        </div>
        <div class="history-row history-property-row">
          <span class="history-label">Property</span>
          <input
            class="history-property-value"
            matInput
            disabled
            readonly
            placeholder="{{changeFieldLabel(change)}}"
            type="text"
            [attr.aria-label]="'Changed property ' + (i + 1)"
          />
        </div>
        <div class="history-row">
          <span class="history-label">Original</span>
          <span class="history-value history-original-value">{{changeValueLabel(change, change.originalValue)}}</span>
        </div>
        <div class="history-row">
          <span class="history-label">New value</span>
          <span class="history-value history-new-value">{{changeValueLabel(change, change.newValue)}}</span>
        </div>
      </li>
    </ul>
  </ng-container>

  <ng-container *ngIf="!isMultiMode && showCutsHistory">
    <h3
      class="mat-h3 properties-section-header"
      [class.is-expanded]="cutsHistoryIsExpanded"
      (click)="cutsHistoryIsExpanded = !cutsHistoryIsExpanded"
    >
      <mat-icon aria-hidden="false" aria-label="Expanded">
        {{ cutsHistoryIsExpanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}
      </mat-icon>
        CUTS
    </h3>

    <ul *ngIf="cutsHistoryIsExpanded" class="cutsHistory expanded-content">
      <ng-container *ngFor="let cut of cutsHistory; let i = index">
        <li class="cut-item">
          <div class="cut-info">
            <span class="cut-label">Cut {{ i + 1 }}</span>
            <span class="cut-date">{{ formatDate(cut.date) }}</span>
          </div>
          <button
            class="cut-undo-action"
            mat-icon-button
            color="warn"
            (click)="deleteCut(cut)"
            title="Undo this cut"
            [attr.aria-label]="'Undo Cut ' + (i + 1)"
          >
            <mat-icon>undo</mat-icon>
          </button>
        </li>
      </ng-container>
    </ul>
  </ng-container>

</ng-template>
<form [formGroup]="baseForm">
  <phdsoft-sideboard
    [options]="optionsWindow"
    [class.has-delete-action]="currentPage === 'properties' && showDeleteElement"
    [class.is-material-page]="currentPage === 'material'"
    [class.is-create-page]="isCreatePage"
    [okDisabled]="(isCreatePage && !canConfirmCreate) || isBusy"
    (ok)="onSideboardOk()"
  >
    <ng-container header>
      <div *ngIf="selectedObject?.Type" style="font-size: 0.7rem !important">
        {{ selectedObject?.Type?.name }}
      </div>
      <div *ngIf="!selectedObject?.Type" style="font-size: 0.7rem !important">
        {{ isMultiMode ? multiCount + ' ELEMENTS SELECTED' : 'PROPERTIES WINDOW' }}
      </div>
    </ng-container>

    <div content class="properties-sideboard-content">
      <div class="box-form" style="max-height: none;" *ngIf="currentPage === 'properties'">
        <div class="properties-actions">
          <button *ngIf="canMultiSelect"
                  class="material-page-next multi-select-toggle"
                  type="button"
                  [class.active]="multiSelectEditActive"
                  [title]="multiSelectEditActive ? 'Stop adding elements to the selection' : 'Tap other elements to edit them together'"
                  (click)="toggleMultiSelectEdit()">
            <mat-icon>{{ multiSelectEditActive ? 'done' : 'library_add' }}</mat-icon>
            <span>{{ multiSelectEditActive ? 'Done' : 'Select more' }}</span>
          </button>
          <button *ngIf="canMultiSelect && multiSelectEditActive"
                  class="material-page-next multi-select-clear"
                  type="button"
                  title="Deselect all elements"
                  (click)="clearMultiSelection()">
            <mat-icon>clear_all</mat-icon>
            <span>Clear</span>
          </button>
          <button class="material-page-next"
                  type="button"
                  [style.visibility]="(isStructuralElement && canChangeMaterial && !isMultiMode) ? 'visible' : 'hidden'"
                  [attr.aria-hidden]="!(isStructuralElement && canChangeMaterial && !isMultiMode)"
                  (click)="goToMaterialPage()">
            <span>Next</span>
            <mat-icon>arrow_forward</mat-icon>
          </button>
        </div>
        <phdsoft-element-type-list
          *ngIf="multiSelectEditActive && canMultiSelect"
          class="multi-select-types"
          [multiple]="true">
        </phdsoft-element-type-list>
        <ng-container *ngIf="baseFormFields?.length > 0">
          <ul
            *ngFor="let field of baseFormFields | phdsoftOrderBy: { expression: 'order', order: null, list: this }"
            [class.is-hidden-field]="!field.visible"
            class="busy-aware-field" [class.is-busy]="isBusy" [attr.inert]="isBusy ? '' : null"
          >
            <ng-container *ngIf="field.visible" ngDefaultControl c4dwebDynamicField [field]="field" [group]="field.formGroup"></ng-container>
          </ul>
        </ng-container>
        <ng-container
          *ngTemplateOutlet="recursiveList; context: { $implicit: baseFormProperties }"
        ></ng-container>
      </div>

      <div class="material-page create-page" *ngIf="isCreatePage">
        <button class="material-page-back" type="button" (click)="cancelCreatePage()">
          <mat-icon>arrow_back</mat-icon>
          <span>Back</span>
        </button>

        <div class="appearance-section">
          <div class="appearance-row create-row">
            <span class="appearance-label">Name</span>
            <input #createNameInput
                   type="text"
                   class="appearance-hex-input create-input"
                   maxlength="120"
                   [ngModel]="createName"
                   [ngModelOptions]="{ standalone: true }"
                   (ngModelChange)="createName = $event"
                   (keydown.enter)="confirmCreatePage()"
                   autocomplete="off" />
          </div>
          <!-- Description input commented out (decision D1, 2026-10-01): the backend stores the
               Name as the region Description and has no field for a free-text description.
          <div class="appearance-row create-row" *ngIf="currentPage === 'newRegion'">
            <span class="appearance-label">Description</span>
            <input type="text"
                   class="appearance-hex-input create-input"
                   maxlength="250"
                   [ngModel]="createDescription"
                   [ngModelOptions]="{ standalone: true }"
                   (ngModelChange)="createDescription = $event"
                   (keydown.enter)="confirmCreatePage()"
                   autocomplete="off" />
          </div>
          -->
          <p class="create-hint">{{ createPageHint }}</p>
        </div>
      </div>

      <div class="material-page" *ngIf="currentPage === 'material'">
        <button class="material-page-back" type="button" (click)="goToPropertiesPage()">
          <mat-icon>arrow_back</mat-icon>
          <span>Back</span>
        </button>

        <div class="appearance-section">
          <div class="appearance-row appearance-preset-row">
            <span class="appearance-label">PRESET</span>
            <p-dropdown
              [(ngModel)]="selectedPreset"
              [ngModelOptions]="{standalone: true}"
              [options]="materialPresets"
              [group]="true"
              optionGroupLabel="label"
              optionGroupChildren="items"
              optionLabel="label"
              placeholder="Select a preset..."
              [showClear]="true"
              appendTo="body"
              styleClass="appearance-preset-dropdown"
              [disabled]="!canChangeMaterial || materialEditSaving"
              (onChange)="onPresetChange($event)">
              <ng-template let-selected pTemplate="selectedItem">
                <span *ngIf="selected">{{ getPresetGroupLabel(selected) }} · {{ selected.label }}</span>
              </ng-template>
            </p-dropdown>
          </div>
          <div class="appearance-row appearance-color-row">
            <span class="appearance-label">COLOR</span>
            <p-colorPicker
              [(ngModel)]="previewColor"
              [ngModelOptions]="{standalone: true}"
              format="hex"
              [inline]="false"
              appendTo="body"
              [disabled]="!canChangeMaterial || materialEditSaving"
              (onChange)="onColorChange($event)">
            </p-colorPicker>
            <input #hexInput
                   type="text"
                   [value]="'#' + previewColor"
                   (input)="onHexInputChange(hexInput.value)"
                   [disabled]="!canChangeMaterial || materialEditSaving"
                   placeholder="#RRGGBB"
                   maxlength="7"
                   class="appearance-hex-input"
                   aria-label="Hex color code">
          </div>
          <div class="appearance-row">
            <span class="appearance-label">OPACITY</span>
            <p-slider
              [(ngModel)]="previewOpacity"
              [ngModelOptions]="{standalone: true}"
              [min]="0.1"
              [max]="1"
              [step]="0.01"
              [disabled]="!canChangeMaterial || materialEditSaving"
              [animate]="false"
              (onChange)="onOpacityChange($event.value)">
            </p-slider>
            <input type="number"
              [(ngModel)]="previewOpacity"
              [ngModelOptions]="{standalone: true}"
              min="0.1" max="1" step="0.01"
              (ngModelChange)="onOpacityChange($event)"
              [disabled]="!canChangeMaterial || materialEditSaving"
              class="appearance-numeric-input">
          </div>
          <div class="appearance-row">
            <span class="appearance-label">ROUGHNESS</span>
            <p-slider
              [(ngModel)]="previewRoughness"
              [ngModelOptions]="{standalone: true}"
              [min]="0"
              [max]="1"
              [step]="0.01"
              [disabled]="!canChangeMaterial || materialEditSaving"
              [animate]="false"
              (onChange)="onRoughnessChange($event.value)">
            </p-slider>
            <input type="number"
              [(ngModel)]="previewRoughness"
              [ngModelOptions]="{standalone: true}"
              min="0" max="1" step="0.01"
              (ngModelChange)="onRoughnessChange($event)"
              [disabled]="!canChangeMaterial || materialEditSaving"
              class="appearance-numeric-input">
          </div>
          <div class="appearance-row">
            <span class="appearance-label">METALNESS</span>
            <p-slider
              [(ngModel)]="previewMetalness"
              [ngModelOptions]="{standalone: true}"
              [min]="0"
              [max]="1"
              [step]="0.01"
              [disabled]="!canChangeMaterial || materialEditSaving"
              [animate]="false"
              (onChange)="onMetalnessChange($event.value)">
            </p-slider>
            <input type="number"
              [(ngModel)]="previewMetalness"
              [ngModelOptions]="{standalone: true}"
              min="0" max="1" step="0.01"
              (ngModelChange)="onMetalnessChange($event)"
              [disabled]="!canChangeMaterial || materialEditSaving"
              class="appearance-numeric-input">
          </div>
        </div>

        <div class="material-page-actions">
          <span *ngIf="pendingMaterialCount > 0" class="pending-badge">{{ pendingMaterialCount }} pending</span>
          <div class="material-page-actions-buttons">
            <button mat-raised-button
                    type="button"
                    [color]="isPaintActive ? 'accent' : ''"
                    [disabled]="materialEditSaving || (!selectedHasCustomMaterial && !isPaintActive)"
                    (click)="togglePaint()"
                    [title]="isPaintActive ? 'Stop painting' : 'Paint with current material'">
              <mat-icon>format_paint</mat-icon>
              <span class="btn-text">{{ isPaintActive ? 'Painting' : 'Paint' }}</span>
              <span *ngIf="isPaintActive" class="brush-swatch" [style.background-color]="paintBrushColor"></span>
            </button>
            <button mat-raised-button
                    type="button"
                    [disabled]="materialEditSaving || !selectedHasCustomMaterial"
                    (click)="setDefault()"
                    title="Reset to default material">
              <mat-icon>format_color_reset</mat-icon>
              <span class="btn-text">Default</span>
            </button>
            <button mat-raised-button
                    class="default-all-btn"
                    type="button"
                    [disabled]="materialEditSaving || !canDefaultAll"
                    (click)="setDefaultAll()"
                    title="Reset every changed material to default">
              <mat-icon>format_color_reset</mat-icon>
              <span class="btn-text">Default All</span>
            </button>
            <button mat-raised-button
                    color="primary"
                    type="button"
                    [disabled]="(pendingMaterialCount === 0 && !appearanceDirty) || materialEditSaving"
                    (click)="finishAndSaveMaterials()"
                    title="Save all changes">
              <mat-icon>save</mat-icon>
              <span class="btn-text">Save All</span>
            </button>
            <button mat-button
                    type="button"
                    [disabled]="materialEditSaving"
                    (click)="discardAllMaterials()"
                    title="Discard all changes">
              <mat-icon>close</mat-icon>
              <span class="btn-text">Discard</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <ng-container footer>
      <button
        *ngIf="currentPage === 'properties' && showDeleteElement && !isMultiMode"
        class="properties-delete-action"
        mat-icon-button
        type="button"
        [disabled]="isBusy"
        (click)="questionDeleteCollection()"
      >
        <mat-icon color="warn" class="mat-18">delete</mat-icon>
      </button>
    </ng-container>
  </phdsoft-sideboard>
</form>
